import { useShowOnlyFirstBet, useUserSettings } from '../common/UserSettingsProvider';
import { useIsDateSection } from '../common/IsDateSectionProvider';
import useIsLiveSection from '../common/useIsLiveSection';
import { useIsLandingSection } from '../landing/LandingSectionProvider';

export function useGetOffsetClass() {
    const userSettings = useUserSettings();
    const singleBetMode = useShowOnlyFirstBet();
    const isLiveSection = useIsLiveSection();
    const isDateSection = useIsDateSection();
    const isLandingSection = useIsLandingSection();

    if (isLandingSection) {
        return '';
    }

    let navbars = 0;
    if (isLiveSection) {
        navbars = 'live';
    } else if (isDateSection) {
        navbars = 'events-by-date';
    } else {
        if (userSettings.compactBetSelector) {
            navbars = 1
        } else if (singleBetMode) {
            navbars = 3;
        } else {
            navbars = 2;
        }
    }
    return `xs_event-info-offset-${navbars}`;
}
